import Axios from "../../configs/axios.config";

// Manager Dashboard APIs
export const getManagerTeamAttendance = (params) =>
  Axios.get(`/managers/${params.manager_id}/team-attendance`, { params })
    .then((response) => response.data.data);

export const markExcuse = (data) =>
  Axios.post(`/attendance/mark-excuse`, data)
    .then((response) => response.data.data);

export const markRemote = (data) =>
  Axios.post(`/attendance/mark-remote`, data)
    .then((response) => response.data.data);

export const markOnLeave = (data) =>
  Axios.post(`/attendance/mark-on-leave`, data)
    .then((response) => response.data.data);

// Shift Management APIs
export const createShift = (data) =>
  Axios.post(`/workspace-shift`, data)
    .then((response) => response.data.data);

export const updateShift = (id, data) =>
  Axios.put(`/workspace-shift/${id}`, data)
    .then((response) => response.data.data);

export const getShiftList = (params) =>
  Axios.get(`/workspace-shift`, { params })
    .then((response) => response.data);

export const getShiftDetail = (id) =>
  Axios.get(`/workspace-shift/${id}`)
    .then((response) => response.data);

export const deleteShift = (id) =>
  Axios.delete(`/workspace-shift/${id}`);

export const bulkAssignShift = (shiftId, data) =>
  Axios.put(`/workspace-shift/${shiftId}`, data)
    .then((response) => response.data.data);

export const bulkUnassignShift = (shiftId, data) =>
  Axios.post(`/shifts/${shiftId}/unassign`, data)
    .then((response) => response.data.data);

export const getShiftAssignments = (shiftId, params) =>
  Axios.get(`/shifts/${shiftId}/assignments`, { params })
    .then((response) => response.data);

export const previewShiftAssignment = (shiftId, data) =>
  Axios.post(`/shifts/${shiftId}/assign/preview`, data)
    .then((response) => response.data.data);

// Attendance Report APIs
export const getAttendanceReport = (params) =>
  Axios.get(`/attendance/report`, { params })
    .then((response) => response.data);

export const exportAttendanceReport = (params) =>
  Axios.get(`/attendance/report/export`, { 
    params,
    responseType: 'blob'
  })
    .then((response) => response.data);

export const scheduleAttendanceReport = (data) =>
  Axios.post(`/attendance/report/schedule`, data)
    .then((response) => response.data.data);

export const saveReportConfiguration = (data) =>
  Axios.post(`/attendance/report/configurations`, data)
    .then((response) => response.data.data);

export const getReportConfigurations = () =>
  Axios.get(`/attendance/report/configurations`)
    .then((response) => response.data.data);

// Attendance Roll-up APIs
export const getPayrollAttendanceRollup = (payrollId) =>
  Axios.get(`/payrolls/${payrollId}/attendance-rollup`)
    .then((response) => response.data.data);

export const bulkAttendanceCorrection = (data) =>
  Axios.post(`/attendance/correction-bulk`, data)
    .then((response) => response.data.data);

// Full-day attendance calculation
export const calculateFullDayAttendance = (data) =>
  Axios.post(`/attendance/calculate-full-day`, data)
    .then((response) => response.data.data);

